import { PropsWithChildren } from 'react';

interface IProps {
    section: string,
    exists: boolean
}

const SectionButton = (props: PropsWithChildren<IProps>) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #A1A1A1',
                backgroundColor: props.exists ? '#8EC89E' : 'white',
                height: 100,
                width: 150,
                borderRadius: 4,
                position: 'relative',
                outline: '0 none'
            }}
        >
            <div className='text-center'>{props.children}</div>
        </div>
    );
}

export default SectionButton;